import { Colors } from 'src/com/sixdee/crbtportal/utils/resources/colors';
import { CheckboxCSSStyleImpl } from '../../../toolkit/checkbox/checkboxcss';

export class DoItYourselfCheckboxCSSStyleImpl extends CheckboxCSSStyleImpl
{
    getCSSStyleOne():Object
    {
        return {
            position: 'relative', 
            width: '20px', 
            height: '20px', 
            cursor: "pointer",
            backgroundColor: this.getResources().getColor(Colors.color_2), 
            borderRadius: '3px'
        };
    }
    getCSSStyleTwo():Object
    {
        return {
            position: 'absolute', height: '4px', 
            width: '9px', top: '7px', left: '5px', 
            borderLeft: 'solid 2px '+ this.getResources().getColor(Colors.color_5), 
            borderBottom: 'solid 2px '+ this.getResources().getColor(Colors.color_5), 
            borderRadius: '0px', 
            cursor: "pointer",
            transform: 'rotate(-45deg)'
        };
    }

    getCSSStyleThree():Object
    {
        return {
            position: 'relative', 
            width: '20px', 
            height: '20px', 
            borderRadius: '3px', 
            cursor: "pointer",
            backgroundColor: this.getResources().getColor(Colors.color_5),
            border: "solid 1px" + this.getResources().getColor(Colors.color_8)
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/doityourself/doityourselfcheckboxcss.tsx